import { shiftMasterApi } from 'Api/shiftMaster';
import { SideDrawerWrapper } from 'components/Global';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import AddShiftBody from './AddShiftBody';
import styles from './index.module.scss';
import ShiftMasterHeader from './Table/Header';
import BranchCodeTable from './Table/ShiftTable';

const ShiftComponent = () => {
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isSideDrawerOpen, setSideDrawerOpen] = useState<boolean>(false);
	const [edit, setEdit] = useState<any>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Shift Master',
	});

	const [shiftData, setShiftData] = useState([]);

	const buttons = [
		{
			text: 'Add Shift',
			isLoading: false,
			className: 'btn-blue',
			// icon: <AddSvg />,
			isSubmit: true,
			onclick: () => {
				openDrawerHandler();
			},
			disabled: isLoading,
		},
	];

	// Open side drawer with animation
	const openDrawerHandler = () => {
		setDrawerInfo({ drawerTitle: 'Add Shift' });
		setDrawerAnimation(true);
		setSideDrawerOpen(true);
	};
	// Remove the side drawer
	const removeDrawerFromDom = () => {
		setSideDrawerOpen(false);
	};

	const editDrawerHandler = (data: any) => {
		setDrawerInfo({ drawerTitle: 'Edit Shift' });
		setEdit(data);
		setDrawerAnimation(true);
		setSideDrawerOpen(true);
	};

	// Close the side drawer with animation
	const closeDrawerByAnimation = () => {
		setEdit(null); //!isAddUserLoading &&
		setDrawerAnimation(false); //!isAddUserLoading &&
	};

	const fetchShiftMaster = async () => {
		try {
			setIsLoading(true);

			const response = await shiftMasterApi.getShiftMasters({});
			setShiftData(response.data.data);
		} catch (err: any) {
			const message =
				err?.response?.data?.message ||
				'Something went wrong in fetching shifts';
			toastText(message, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchShiftMaster();
	}, []);

	return (
		<div>
			<div className={styles['employee-container']}>
				<ShiftMasterHeader
					isAdd={shiftData.length < 2}
					button={buttons}
				/>
				<BranchCodeTable
					shiftData={shiftData}
					isLoading={isLoading}
					editDrawerHandler={editDrawerHandler}
				/>
			</div>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<AddShiftBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						editSelected={edit}
						setEditSelectedUser={setEdit}
						fetchShiftMaster={fetchShiftMaster}
					/>
				</SideDrawerWrapper>
			)}
		</div>
	);
};

export default ShiftComponent;
